// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import * as GuildCommands from '@app/features/guild/commands/GuildCommands';
import SelectedGuild from '@app/features/navigation/state/SelectedGuild';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {Logger} from '@app/features/platform/utils/AppLogger';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';

const logger = new Logger('useLeaveGuild');
export const useLeaveGuild = () => {
	const {t} = useLingui();
	return useCallback(
		(guildId: string) => {
			ModalCommands.push(
				modal(() => (
					<ConfirmModal
						title={t`Leave Community`}
						description={t`Are you sure you want to leave this community? You will no longer be able to see any messages.`}
						primaryText={t`Leave Community`}
						primaryVariant="danger-primary"
						onPrimary={async () => {
							try {
								const wasSelected = SelectedGuild.selectedGuildId === guildId;
								await GuildCommands.leave(guildId);
								if (wasSelected) {
									RouterUtils.transitionTo(Routes.ME);
								}
								ToastCommands.createToast({
									type: 'success',
									children: t`Left community`,
								});
							} catch (error) {
								logger.error('Failed to leave community', error);
								window.setTimeout(() => {
									ModalCommands.push(
										modal(() => (
											<GenericErrorModal
												title={t`Failed to Leave Community`}
												message={t`We couldn't remove you from the community at this time.`}
											/>
										)),
									);
								}, 0);
							}
						}}
					/>
				)),
			);
		},
		[t],
	);
};
